import React, { useEffect } from "react"
import Layout from '../../NewComponent/LayoutAdmin/Layout';
import { Box } from "@mui/material"
import VizHeader from "../../Component/VizHeader/VizHeader"
import { useDispatch, useSelector } from "react-redux"
import { bindActionCreators } from "redux"
import { Actions } from "../../Action"
import { getGroupInfoAdmin, getRoutingLevelsAdmin, getCurationRoutingAdminValues, getCurationRoutingAdminValuesByGroups } from "../../API/api";
import VizParagraph from "../../Component/VizParagraph/VizParagraph"
import moment from "moment"
import AdminCardComponent from "../../Component/AdminCardComponent/AdminCardComponent"
import { Grid } from "@mui/material"
import GlobalSettingsBox from "../../Component/GlobalSettingsBox/GlobalSettingsBox"
import { settingListAdmin } from "../../utils"
import { toast } from "react-toastify";
import { Spin } from "antd"
import GlobalSettingsBox2 from "../../Component/GlobalSettingsBox/GlobalSettingsBox2"



export default function AdminSettingsPage() {
	const errorMessage = (message) => {
		return (
			<span style={{fontSize:'12px'}}>{message}</span>
		)
	}
	const dispatch = useDispatch()
	const { isLoadingAdminData,getCurationGroupValueAdmin, getCurationRoutingValues, adminSettingsGroupInfo, adminSettingsRoutingLevels } = bindActionCreators(Actions, dispatch)
	const adminSettingReducer = useSelector((state) => state.adminSettings);
	useEffect(() => {
		getGroupInfoAdmin().then((res) => {
			if(res===undefined) return;
			isLoadingAdminData(true)
			if (res.data.data !== undefined || res.data.success) {
				adminSettingsGroupInfo(res.data.data)
				isLoadingAdminData(false)
			}
		}).catch((e) => {
			toast.error(errorMessage(e), {
				position: toast.POSITION.TOP_RIGHT
			})
		})
		getRoutingLevelsAdmin().then((res) => {
			if(res===undefined) return;
			isLoadingAdminData(true)
			if (res.data.data !== undefined || res.data.success) {
				adminSettingsRoutingLevels(res.data.data)
				isLoadingAdminData(false)
			}
		}).catch((e) => {
			toast.error(errorMessage(e), {
				position: toast.POSITION.TOP_RIGHT
			})
		})
		getCurationRoutingAdminValues().then((res) => {
			if(res===undefined) return;
			isLoadingAdminData(true)
			if (res.data.data !== undefined || res.data.success) {
				getCurationRoutingValues(res.data.data)
				isLoadingAdminData(false)
			}
			getCurationRoutingAdminValuesByGroups().then((res) => {
				if(res===undefined) return;
				isLoadingAdminData(true)
				if (res.data.data !== undefined || res.data.success) {
					getCurationGroupValueAdmin(res.data.data)
					isLoadingAdminData(false)
				}
			}).catch((e) => {
				toast.error(errorMessage(e), {
					position: toast.POSITION.TOP_RIGHT
				})
			})
		}).catch((e) => {
			toast.error(errorMessage(e), {
				position: toast.POSITION.TOP_RIGHT
			})
		})
		// localStorage.removeItem('tabKeyRerouting')
		// localStorage.removeItem('tabKeyAbortPeriod')
		// localStorage.removeItem('tabKeyForExpertsAssigned')
		localStorage.setItem('tabKeyRerouting','reroutingIntervalCountryDays')
		localStorage.setItem('tabKeyAbortPeriod','abortPeriodCountry')
		localStorage.setItem('tabKeyForExpertsAssigned','expertsAssignedCountry')
	}, [])

	return (
		<>
				<Box sx={{ width: '95%', marginLeft: 'auto', marginRight: 'auto',marginBottom:'4%' }}>
				<Layout>
					{adminSettingReducer.settingId === 0 && <div style={{ textAlign: 'center',paddingBottom:'5px' }}><VizHeader type={3} isBold={true}>Global Settings</VizHeader></div>}
					{/* <AdminSettingsCollapsibleComponent /> */}
					{/* {adminSettingReducer.settingId === 0 && <AdminCardComponent />} */}
					{adminSettingReducer.settingId === 0 &&
						<>
							<Grid container gap={1} xs={12} sm={12} md={12} lg={12} xl={12}>
								{
									Object.keys(settingListAdmin).map((obj, ind) => {
										return (
											<Grid item xs={12} sm={12} md={12} lg={2.9} xl={2.9}>
												<AdminCardComponent val={obj} ind={ind} />
											</Grid>
										)
									})
								}
							</Grid>
						</>
					}
					{adminSettingReducer.settingId !== 0 &&
					(adminSettingReducer?.groupInfoData.length > 0) &&
					(adminSettingReducer?.routingLevelsData.length > 0) &&
					(adminSettingReducer?.curationRoutingOptions.length > 0) &&
					(adminSettingReducer?.curationRoutingValueByGroup.length >= 0) &&	
					// (<GlobalSettingsBox />)}
					(<GlobalSettingsBox2 />)}
					{/* {adminSettingReducer?.settingId !== 0 &&
						adminSettingReducer?.isLoading === false &&
						(<GlobalSettingsBox />)} */}
					{/* {adminSettingReducer?.isLoading && <Spin indicator={adminSettingReducer?.isLoading} /> } */}
					<div style={{paddingTop:'5px',paddingBottom:'5px'}}><VizParagraph type={4}>Last Modified:{" "}<b>{moment(adminSettingReducer.groupInfoData[0]?.modifiedDate).format('MMM DD, YYYY')}</b></VizParagraph></div>
					</Layout>
				</Box>
		</>
	)
}
